import { useEntityBaseMetadata, useMessagesMetadata } from '@msdk/common'
import { EntityMetadata, FieldDefinition, FormNode, Severity } from '@msdk/definitions'
import { COLORS } from '@msdk/ui'

const exclude = [Severity.Mandatory]

function isValidationColors(value: string): value is keyof typeof COLORS.validation {
  return Object.keys(COLORS.validation).includes(value)
}

function lcfirst(s: string) {
  return s.charAt(0).toLocaleLowerCase() + s.slice(1)
}

export function useFieldSeverity(
  fieldDef: FieldDefinition,
  node: FormNode,
): keyof typeof COLORS.validation | undefined {
  const baseMetadata = useEntityBaseMetadata(fieldDef.entityName) as EntityMetadata
  const messages = useMessagesMetadata(baseMetadata?.msProvider) || []
  const msgToShow = messages.filter((m) => node.value.validationMessages.includes(m.code))

  const types = msgToShow.map((m) => m.type).filter((t) => !exclude.includes(t))
  const mostSevereType = Math.min(...types)
  const severity = lcfirst(Severity[mostSevereType] ?? '')

  return isValidationColors(severity) ? severity : undefined
}
